import axios from 'axios';
import AuthService from './auth.service';
import { UNKNOWN_ERROR } from '../constants/errors.jsx';
import { refreshToken } from '../actions/users';
import _ from 'lodash';

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

const apiUrl = process.env.REACT_APP_API_URL;
const usersApi = process.env.REACT_APP_USERS_API_URL;

const OAUTH_URL = `${usersApi}/users/3.0/oauth/token`;

export default function () {

  axios.interceptors.request.use(function (config) {
    if (AuthService.isAuthenticated()) {
      if((config.url.startsWith(apiUrl) && !config.url.startsWith(OAUTH_URL)) || config.url.startsWith(usersApi)) {
        config.headers.Authorization = 'Bearer ' + AuthService.getAccessToken();
      }
    }
    
    if(config.url.startsWith(apiUrl)) {
      config.headers['PF-PLATFORM'] = "CHROME_" + AuthService.getIntegrationType();
      config.headers['PF-VERSION'] = "1.0.0";
    }
    return config;
  });

  //Intercept response and prepare the error object
  axios.interceptors.response.use((response) => {
    return response
  }, (error) => {

    const { config } = error;
    const originalRequest = config;

    const status = _.get(error, "response.status", null);
    console.log(status);
    if (status === 401) {
      if (config.url.endsWith('oauth/token') || config.url.endsWith('users/logout')) {
        return Promise.reject(error);
      }


      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;
        var refreshTokenValue = AuthService.getRefreshToken();

        refreshToken(refreshTokenValue).then((token) => {
          isAlreadyFetchingAccessToken = false

          if (token && token.data && token.data.access_token) {
            handleSaveToken(token.data.access_token, token.data.refresh_token);
          }
        }).catch(err => {
          isAlreadyFetchingAccessToken = false;
          subscribers = [];

          if (window.location.pathname !== '/login'){
            window.location.replace('/login');
          }

          AuthService.clearAccessToken();
          
          return Promise.reject("Auth error");
        })
      }

      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(access_token => {
          originalRequest.headers.Authorization = 'Bearer ' + access_token
          resolve(axios(originalRequest))
        })
      })

      return retryOriginalRequest
    }


    console.log("Unknown error :" + error);

    let errorMessage = '';

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    } else {
      return Promise.reject({
        code: UNKNOWN_ERROR,
        message: "Oops, Unable to complete the request"
      });
    }
  })
}

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

function handleSaveToken(access_token, refresh_token) {

  AuthService.saveToken(access_token, refresh_token);
  onAccessTokenFetched(access_token);

  window.parent.postMessage({
    type: "PAPERFLITE_AUTHENTICATION",
    refresh_token: refresh_token,
    access_token: access_token
  }, '*');
}

function handleResponseError(response) {
  if (!response.ok) {
    if (response.status === 401) {
      console.error('Unauthorized: Please log in.');
    } else if (response.status === 403) {
      console.error('Forbidden: You do not have permission to access this resource.');
    } else {
      console.error(`HTTP Error ${response.status}: ${response.statusText}`);
    }
  }
  return response;
}


export function interceptPost(url, request, token) {

  // Perform the POST request.
  return fetch(url,{
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'PF-PLATFORM': 'CHROME',
        'PF-VERSION': '1.0.0',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(request)
    })
    .then(handleResponseError)
    .catch((error) => {
      console.error('Network error:', error);
      throw error;
    });
}